
import Vue from 'vue'
import App from './App'
import store from './store' // login.js中有调用到store，注意顺序问题，但打包后报错好像不是这个原因
import router from './router'
import API from './sevice/API'
import './login.js'
import '@/assets/iconfont/iconfont.css'//引入阿里巴巴项目图标
import 'iview/dist/styles/iview.css';
import './styles/common.scss';
import './styles/change.scss';
import iView from 'iview';
import 'babel-polyfill';
import './utils/protocolcheck.js' // 用于判断是否可以打开IE

import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  ak: 'yWeTMhtyE0L1I6skhTFh5MxxOst2a9Tu',//公司
})


import Viewer from 'v-viewer'
Vue.use(Viewer);

import vueBus from '@/utils/vue-bus.js'
Vue.use(vueBus);

import SlideVerify from 'vue-monoplasty-slide-verify';
Vue.use(SlideVerify);

// import map from 'echarts/lib/chart/map';
// Vue.use(map);
// 升级echarts版本 这个文件不存在从4.0.9升级到5.1.0
Vue.config.silent = true
// 引入自定义组件。index.js是组件的默认入口
import Loading from './components/common/loading/index.js'
Vue.use(Loading);
Vue.use(iView);
Vue.config.productionTip = false;
Vue.prototype.api = API;
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});

//动态重载路由，使用：页面刷新
function refreshRouter() {
  //路由根据store缓存重载:管理界面
  store.state.sys.routers.forEach(item => {
    item.component = resolve => {require([ './components/manage/' + 'Layout' + '.vue'], resolve)},
      item.children.forEach(child => {
        child.component = resolve => {require([ './components/managePage/' + child.meta.local + '.vue'], resolve)}
        child.children.forEach(grandchild => {
          grandchild.component = resolve => {require([ './components/managePage/' + grandchild.meta.local + '.vue'], resolve)}
        })
      })
  })
  //路由根据store缓存重载:大屏界面
  store.state.user.menuRouter.forEach(item => {
    item.component = resolve => {require([ './components/unit.vue'], resolve)},
      item.children.forEach(child => {
        child.component = resolve => {require([ './components/super/' + child.type.replace('super/','') + '.vue'], resolve)}
      })
  })
  router.addRoutes(store.state.user.menuRouter);
  router.addRoutes(store.state.sys.routers);
}

//refreshRouter();

// 引入全局过滤器
import * as filters from './utils/filters.js'
Object.keys(filters).forEach(key=>{
    Vue.filter(key,filters[key]) // 插入过滤器名和对应方法
})



// WEBPACK FOOTER //
// ./src/main.js